import { useAuth } from '../context/auth-context';
import { UserRole } from '../types/user.types';

export const useIsUserRole = (roles: UserRole[]) => {
  const { currentUser } = useAuth();

  return currentUser?.role && roles.includes(currentUser.role);
};
